import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import tabMenu from './tabMenu';
import tabMenuSaga from './tabMenu/saga';
import tabImage from './tabImage';
import tabImageSaga from './tabImage/saga';
import searchKeyword from './searchKeyword';
import tabAI from './tabAI';
import tabAISaga from './tabAI/saga';
import tabResult from './tabResult';
import tabResultSaga from './tabResult/saga';
import tabSimilarImage from './tabSimilarImage';
import tabSimilarImageSaga from './tabSimilarImage/saga';

import main from './main';
import mainSaga from './main/saga';

import common, { commonSaga } from './common';

const rootReducer = combineReducers({
  tabMenu,
  tabImage,
  searchKeyword,
  tabAI,
  tabResult,
  tabSimilarImage,
  main,
  common,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
export function* rootSaga() {
  yield all([
    tabMenuSaga(),
    tabAISaga(),
    tabResultSaga(),
    tabImageSaga(),
    tabSimilarImageSaga(),
    mainSaga(),
    commonSaga(),
  ]);
}
